import {useMap} from "@vis.gl/react-google-maps";
import {useEffect, useRef} from "react";

export default function RoutePolyline({ path, options }) {
    const map = useMap();
    const polylineRef = useRef(null);

    useEffect(() => {
        if (!map) return;

        polylineRef.current = new google.maps.Polyline({
            map,
            path,
            ...options,
        });

        return () => {
            polylineRef.current?.setMap(null);
            polylineRef.current = null;
        };
    }, [map, path, options]);

    useEffect(() => {
        if (!polylineRef.current) return;
        polylineRef.current.setPath(path);
    }, [path]);

    useEffect(() => {
        if (!polylineRef.current) return;
        polylineRef.current.setOptions(options);
    }, [options]);

    return null;
}